export const NOTIFICATIONS_ID = 'notifications';
